import React from 'react';
import { formatTimeAgo } from '../utils/formatters';
import InfoTip from './InfoTip';

export default function KPICard({ label, value, change, lastUpdated, prefix = '', info, secondary }) {
  const isPositive = change > 0;
  const isNegative = change < 0;

  // Keep the icon tied to the final word. As a plain sibling of the text it
  // wrapped onto a line of its own once the label filled the card, which read
  // as a blank row.
  const words = String(label ?? '').split(' ');
  const leadingWords = words.slice(0, -1).join(' ');
  const lastWord = words[words.length - 1] ?? '';

  return (
    <div className="kpi-card">
      <div className="kpi-label">
        {leadingWords && leadingWords + ' '}
        <span style={{ whiteSpace: 'nowrap' }}>{lastWord}<InfoTip text={info} label={label} /></span>
      </div>
      <div className="kpi-value" style={secondary ? { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' } : undefined}>
        <span>{prefix}{value}</span>
        {secondary && <span style={{ fontSize: '13px', fontWeight: 500, color: 'var(--text-secondary)' }}>{secondary}</span>}
      </div>
      {change !== undefined && change !== null && (
        <div className={`kpi-change ${isPositive ? 'positive' : isNegative ? 'negative' : ''}`}>
          {isPositive ? '+' : ''}{typeof change === 'number' ? change.toFixed(1) : change}%
        </div>
      )}
      {lastUpdated && <div className="kpi-updated">Updated {formatTimeAgo(lastUpdated)}</div>}
    </div>
  );
}
